import {Directive, HostBinding, Input} from '@angular/core';

@Directive({
    selector: '[ui-table]',
    standalone: false
})
export class UiTableDirective {
    private _isLoading = false;
    private _isEmpty = false;
    private _emptyText = 'Nenhum dado foi encontrado!';

    @Input() set loading(value: boolean) {
        this._isLoading = value;
        this.isLoading = value;
        this.updateEmptyState();
    }

    @Input() set empty(value: boolean) {
        this._isEmpty = value;
        this.updateEmptyState();
    }

    @Input('empty-text') set emptyText(value: string) {
        this._emptyText = value || 'Nenhum dado foi encontrado!';
    }

    @HostBinding('class.ui-table') isTable = true;
    @HostBinding('class.empty-table') isEmpty = false;
    @HostBinding('class.ui-loading') isLoading = false;
    @HostBinding('attr.empty-text') get getEmptyText() {
        return this._emptyText;
    }

    // Atualiza o estado de isEmpty com base em isLoading
    private updateEmptyState(): void {
        this.isEmpty = !this._isLoading && this._isEmpty;
    }
}
